import { useState } from "react";

import HeaderNav from "../headerNav";

import DataForm from "../dataForm";
import Modal from "../modal";
import Footer from "../footer";
import Button from "../button"

import "./index.scss";
const Register = () => {

    const [ isModalOpen, setIsModalOpen ] = useState(false);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    }   
    const handleCloseModal = () => {
        setIsModalOpen(false);
    }
 

    return (
        <>
            <section>
                <HeaderNav />
            </section>


            <section className="container-modal">
                {!isModalOpen && (
                    <Button onClick={handleOpenModal} text="Inscrever-se" />
                )}

                {isModalOpen && (
                    <Modal onClose={handleCloseModal}>
                        <DataForm />
                    </Modal>
                )}
            
            </section>

            <Footer />
        
        
        </>
    )
}

export default Register;